// removed by extract-text-webpack-plugin
module.exports = {"downloadButtonsContainer":"_3cB-4","appStoreLink":"_24jCK","googlePlayLink":"_2GK3Z"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AppStoreBadges/index.sass
// module id = 1458
// module chunks = 1